/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MfSelectorA85Enum {
    BIGGEST = 'biggest',
    REJECT = 'reject',
}